import {Typography} from '@mui/material';
import _, {isArray} from 'lodash';
import React, {ReactNode} from 'react';
import {themmeColor} from 'src/constants/constants';
import RightChveron from 'src/icons/RightChveron';
import {getFieldValue} from '../CpaCenterV2.utils';
import Text from 'src/DesignSystem/Form/common/Text/Text';
import {
  FONT_WEIGHTS,
  TEXT_TYPES,
} from 'src/DesignSystem/Form/common/Text/Text.types';

export enum TABLE_DATA_TYPE {
  HEADING = 'HEADING',
}

interface KeyValueTableProps {
  data: any[];
  keys: {
    getValue: (rowData: any, index: number) => any;
    textStyle?: React.CSSProperties;
    cellStyle?: React.CSSProperties;
    onClick?: (rowData: any, index: number) => void;
    getIcon?: (rowData: any, index: number) => ReactNode;
    noOnClickIcon?: boolean;
  }[];
  header?: string[];
}

const KeyValueTable = ({data, keys, header}: KeyValueTableProps) => {
  return (
    <div
      style={{
        backgroundColor: themmeColor.cpaCenterV2Bg,
        borderRadius: 12,
        borderStyle: 'solid',
        borderColor: themmeColor.offWhite,
        borderWidth: 1,
      }}>
      {isArray(header) ? (
        <div
          style={{
            display: 'flex',
            paddingBlock: 12,
            paddingInline: 16,
            justifyContent: 'space-between',
            borderBottomStyle: 'solid',
            borderBottomColor: themmeColor.offWhite,
            borderBottomWidth: 1,
            alignItems: 'center',
          }}>
          {header.map((title) => (
            <Text
              type={TEXT_TYPES.BASE}
              fontWeight={FONT_WEIGHTS.SemiBold}
              text={title}
              containerStyle={{display: 'flex', flex: 1}}
            />
          ))}
        </div>
      ) : null}
      {data.map((rowData: any, rowIndex: number) => {
        const isLast = data.length - 1 === rowIndex;
        return (
          <div
            key={rowIndex}
            style={{
              display: 'flex',
              paddingBlock: 12,
              paddingInline: 16,
              justifyContent: 'space-between',
              borderBottomStyle: isLast ? 'none' : 'solid',
              borderBottomColor: themmeColor.offWhite,
              borderBottomWidth: isLast ? 0 : 1,
              alignItems: 'center',
            }}>
            {/* Row */}
            {keys.map(
              (
                {
                  textStyle = {},
                  getValue,
                  cellStyle = {},
                  onClick,
                  getIcon,
                  noOnClickIcon = false,
                },
                index,
              ) => {
                const value = getValue(rowData, index);
                return (
                  <div
                    onClick={
                      onClick ? () => onClick(rowData, index) : undefined
                    }
                    key={`${value}-${index}`}
                    style={{flex: 1, ...cellStyle}}>
                    {/* Cell */}
                    <Typography style={{...textStyle}}>
                      {getFieldValue(value)}
                    </Typography>
                    {getIcon && getIcon(rowData, index)}
                    {!noOnClickIcon && onClick && (
                      <div style={{display: 'flex'}}>
                        <RightChveron />
                      </div>
                    )}
                  </div>
                );
              },
            )}
          </div>
        );
      })}
    </div>
  );
};

export default KeyValueTable;
